import {AppContext, initApp} from './utils/app-init';
import {SplideIntegration} from './libs/splide-integration';
import {IadLeadForm} from './app/iad-lead-form';
import {gtag, postConversion} from './utils/conversion';
import {CallIntentButton} from './utils/call-intent-button';

initApp((context: AppContext) => {
	const form: HTMLFormElement = document.querySelector('#lead-gen-form') as HTMLFormElement;
	const formParentElement: HTMLElement = document.querySelector('.form') as HTMLElement;
	new IadLeadForm(form, formParentElement, context, [], 'WjoUCOTig80DEPfb-pQB').initFormInputBehavior();
	new SplideIntegration('#splide').initSplide();

	new CallIntentButton(context)
		.init()
		.onClick((e) => {
			gtag('event', 'conversion', {'send_to': 'AW-312389111/ZfgvCO6IleIDEPfb-pQB'});
			postConversion('Contact');
		});
	postConversion('PageView');
});
